import React from 'react';

interface VenereProgressBarProps {
  progress: number; // 0-100
  variant?: 'royal' | 'navy' | 'neon' | 'purple' | 'matcha' | 'success' | 'warning' | 'error';
  className?: string;
  showLabel?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const VenereProgressBar: React.FC<VenereProgressBarProps> = ({
  progress,
  variant = 'royal',
  className = '',
  showLabel = false,
  size = 'md',
}) => {
  const clampedProgress = Math.min(100, Math.max(0, progress));

  const variantClasses = {
    royal: 'bg-[var(--venere-royal)]',
    navy: 'bg-[var(--venere-navy)]',
    neon: 'bg-[var(--venere-neon)]',
    purple: 'bg-[var(--venere-purple)]',
    matcha: 'bg-[var(--venere-matcha)]',
    success: 'bg-[var(--venere-success)]',
    warning: 'bg-[var(--venere-warning)]',
    error: 'bg-[var(--venere-error)]',
  };

  const sizeClasses = {
    sm: 'h-1',
    md: 'h-2',
    lg: 'h-3',
  };

  return (
    <div className={`w-full ${className}`}>
      {showLabel && (
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-[var(--venere-navy)]">Progress</span>
          <span className="text-sm text-[var(--venere-slate)]">{Math.round(clampedProgress)}%</span>
        </div>
      )}
      <div className={`w-full bg-[var(--venere-platinum)] rounded-full ${sizeClasses[size]}`}>
        <div
          className={`${variantClasses[variant]} ${sizeClasses[size]} rounded-full transition-all duration-500 ease-out`}
          style={{ width: `${clampedProgress}%` }}
        />
      </div>
    </div>
  );
};

export default VenereProgressBar; 